import { Editor as TinyMCEEditor } from "tinymce";
import {
  FindOfficeLocationsQuery,
  FindOrganisationalUnitsQuery,
  UpdateProposalHtmlMutationVariables,
} from "~/gql/graphql";

type UpdateProposalHtmlFunc = ({
  variables,
  onCompleted,
}: {
  variables: UpdateProposalHtmlMutationVariables;
  onCompleted: () => void;
}) => void;

export const addOfficeMenuItem = (
  editor: TinyMCEEditor,
  offices: FindOfficeLocationsQuery["officeLocations"],
  matterId: number,
  refetch: () => void,
  updateProposalHtml: ({
    variables,
    onCompleted,
  }: {
    variables: UpdateProposalHtmlMutationVariables;
    onCompleted: () => void;
  }) => void,
  selectedOfficeId?: number | null,
  selectedTemplateId?: number | null
) => {
  const currentOffice = offices?.find((x) => x.id === selectedOfficeId);
  editor.ui.registry.addNestedMenuItem("changeOffice", {
    text: currentOffice ? `Change Office (${currentOffice.name})` : `Change Office`,
    getSubmenuItems: () => {
      return offices?.map((office) => ({
        type: "menuitem",
        text: office.name,
        icon: currentOffice?.id === office.id ? "selected" : undefined,
        onAction: () => {
          if (!office.id || !selectedTemplateId) return;
          updateProposalHtml({
            variables: {
              update: {
                selectedOfficeId: office.id,
                designTemplateId: selectedTemplateId,
                matterId,
              },
            },
            onCompleted: () => {
              addOfficeMenuItem(
                editor,
                offices,
                matterId,
                refetch,
                updateProposalHtml,
                office.id,
                selectedTemplateId
              );
              refetch();
            },
          });
        },
      }));
    },
  });
};

export const addPracticeAreaMenuItem = (
  ed: TinyMCEEditor,
  practiceAreas: FindOrganisationalUnitsQuery,
  updateProposalHtml: UpdateProposalHtmlFunc,
  matterId: number,
  refetch: () => void,
  selectedPracticeAreaId?: number | null,
  selectedTemplateId?: number | null
) => {
  const currentPracticeArea = practiceAreas?.organisationalUnits.find(
    (x) => x.id === selectedPracticeAreaId
  );
  ed.ui.registry.addNestedMenuItem("changePracticeArea", {
    text: currentPracticeArea
      ? `Change Practice Area (${currentPracticeArea.name})`
      : `Change Practice Area`,
    getSubmenuItems: () => {
      return practiceAreas?.organisationalUnits
        .filter((x) => !x.parent?.id)
        .map((pa) => {
          return {
            type: "nestedmenuitem",
            icon: pa.children?.some((x) => x.id === currentPracticeArea?.id)
              ? "selected"
              : undefined,
            text: pa.name,
            getSubmenuItems: () => {
              return (
                pa.children?.map((y) => ({
                  type: "menuitem",
                  text: y.name,
                  icon: currentPracticeArea?.id === y.id ? "selected" : undefined,
                  onAction: () => {
                    if (!y.id || !selectedTemplateId) return;
                    updateProposalHtml({
                      variables: {
                        update: {
                          selectedOrganisationalUnitId: y.id,
                          designTemplateId: selectedTemplateId,
                          matterId,
                        },
                      },
                      onCompleted: () => {
                        addPracticeAreaMenuItem(
                          ed,
                          practiceAreas,
                          updateProposalHtml,
                          matterId,
                          refetch,
                          y.id,
                          selectedTemplateId
                        );
                        refetch();
                      },
                    });
                  },
                })) || []
              );
            },
          };
        });
    },
  });
};
